import { Pipe, PipeTransform } from "@angular/core";
import { ICoordinate } from "@ramudden/models/location";

@Pipe({
    name: "coordinate",
})
export class CoordinatePipe implements PipeTransform {
    transform(coordinate: ICoordinate): string {
        if (!coordinate) return null;

        return `(${coordinate.latitude?.toFixed(6)}, ${coordinate.longitude?.toFixed(6)})`;
    }
}
